import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Bell = createReactComponent("Bell", ["svg", defaultAttributes, [["path", {
  d: "M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9",
  key: "1wwper"
}], ["path", {
  d: "M13.73 21a2 2 0 01-3.46 0",
  key: "41ys2d"
}]]]);
export default Bell;